import { OverviewActivityPreview } from "@/components/activity/OverviewActivityPreview";

/**
 * Lead-page wrapper for the shared <c>OverviewActivityPreview</c>.
 *
 * The shared primitive was introduced in Layout Compliance v1.0 PR 5
 * (Lead) and generalized in PR 6 (Broker). This thin wrapper preserves
 * the `lead-overview-activity-preview` test id and the
 * `/leads/{id}?tab=activity` link target the LeadDetailPage tests rely
 * on, while every other entity rollout (Broker / PR 6 onwards) imports
 * the shared component directly.
 */
interface Props {
  leadId: string;
}

export function LeadOverviewActivityPreview({ leadId }: Props) {
  return (
    <OverviewActivityPreview
      ownerType="lead"
      ownerId={leadId}
      detailPath={`/leads/${leadId}`}
      testId="lead-overview-activity-preview"
    />
  );
}
